import React, { lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";
import CustomMeta from "../components/CustomMeta/CustomMeta";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { makeStyles } from "tss-react/mui";

const BlogGeneratorLanding = lazy(() =>
  import(
    /* webpackChunkName: "BlogGeneratorLanding" */ "../components/BlogGenerator/BlogGeneratorLanding"
  )
);

const useStyles = makeStyles()(() => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#f8f9fa",
  },
}));

function blogGenerator(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title="AI Blog Generator for WordPress - Content Generator"
        description="Automatically generate SEO blog posts for your WordPress site. Connect your site, add keywords, and publish AI-written articles with images on a daily schedule."
        url="https://contentgenerator.io/blog-generator"
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <BlogGeneratorLanding authenticated={props.user.authenticated} />
        </Suspense>
      )}
    </div>
  );
}

blogGenerator.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(blogGenerator);
